import React from 'react';
import { ToastContainer } from 'react-toastify';
import { inter } from './consts';
import AlertModal from '@components/Alert';
import LanguageSwitcher from '@components/LangSwitcher';
import { LAYOUT_CONTAINER_WIDTH_PX } from '@constants/layout';

import 'react-toastify/dist/ReactToastify.css';

type Props = {
  children: React.ReactNode;
  hideLanguageSwitcher?: boolean;
};

export function Layout({ children, hideLanguageSwitcher }: Props) {
  return (
    <>
      <div
        className={`fadeIn relative flex h-full min-h-screen w-full min-w-[350px] justify-center overflow-auto bg-bg-primary md:p-8 ${inter.className}`}
      >
        {!hideLanguageSwitcher && (
          <LanguageSwitcher className='absolute right-6 top-6 ml-3 hidden md:flex' />
        )}
        <div className='h-full w-full p-4 md:h-auto md:p-0' style={{ maxWidth: LAYOUT_CONTAINER_WIDTH_PX }}>
          {children}
        </div>
      </div>
      <AlertModal />
      <ToastContainer />
    </>
  );
}
